// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AdminPracticeTemplateFieldResponse } from './admin-practice-template-field-response';

/** See com.rev360.pms.api.controller.admin.communicationtemplate.AdminDocumentTemplateFieldCategoryResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminDocumentTemplateFieldCategoryResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	categoryIdentifier!: string;

	@GandalfProperty({ designType: String })
	categoryLabel!: string;

	@GandalfArray(AdminPracticeTemplateFieldResponse)
	fields!: AdminPracticeTemplateFieldResponse[];

	@GandalfArray(AdminDocumentTemplateFieldCategoryResponse)
	subCategories!: AdminDocumentTemplateFieldCategoryResponse[];

}
